import { imageStore } from '../images.js';
import Drawable from '../entities/Drawable.js';
import Sprite from '../ui/Sprite.js';
import PixelText from './PixelText.js';

export default class SaveFileOption extends Drawable {
    constructor({ position, slotData }) {
        super({ position });
        this.slotData = slotData;
        this.sprite = new Sprite({
            position: position,
            image: imageStore.get('img/save_file_box.png'),
        });
        this.playerName = slotData.playerName;
        this.lastSave = slotData.lastSave;
        this.pokedex = slotData.pokedex;

        let dateString = '--';
        if (slotData.lastSave !== null && slotData.lastSave !== undefined) {
            dateString = this.formatTimestamp(slotData.lastSave);
        }

        const playerNameStr =
            slotData.lastSave === null || slotData.lastSave === undefined
                ? 'New Game'
                : `${slotData.playerName  } | ${dateString}`;

        this.playerNameText = new PixelText({
            text: playerNameStr,
            position: {
                x: this.position.x + 8,
                y: this.position.y + (this.playerName === 'New Game' ? 12 : 7),
            },
            textAlign: 'left',
            color: 'black',
        });

        this.pokedexText = new PixelText({
            text: `Pokedex: ${slotData.pokedex ?? '--'}`,
            position: {
                x: this.position.x + 8,
                y: this.position.y + 17,
            },
            textAlign: 'left',
            color: 'black',
        });
    }

    formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${month}/${day}/${year} @ ${hours}:${minutes}`;
    }

    update(slotData) {
        this.slotData = slotData;
        if (slotData.playerName === null || slotData.playerName === undefined) {
            this.playerNameText.position.y = this.position.y + 12;
        }
        this.playerName = slotData.playerName || 'New Game';
        this.lastSave = slotData.lastSave;
        this.pokedex = slotData.pokedex;

        let dateString = '--';
        if (slotData.lastSave !== null && slotData.lastSave !== undefined) {
            dateString = this.formatTimestamp(slotData.lastSave);
        }

        const playerNameStr =
            slotData.lastSave === null || slotData.lastSave === undefined
                ? 'New Game'
                : `${slotData.playerName  } | ${dateString}`;

        this.playerNameText.text = playerNameStr;
        this.pokedexText.text = `Pokedex: ${slotData.pokedex ?? '--'}`;
    }

    draw() {
        this.update(this.slotData);
        this.sprite.draw();
        if (this.playerNameText.text === 'New Game') {
            this.playerNameText.position.y = this.position.y + 12;
        }
        this.playerNameText.draw();
        if (this.playerName === 'New Game') {
            return;
        }
        this.pokedexText.draw();
    }
}
